import TabsLayoutHeading from 'components/dashboard/common/TabsLayoutHeading/TabsLayoutHeading';
import React from 'react';

const AppIntegrationHeading = () => {
    return (
        <TabsLayoutHeading title={`Connected Apps`} subTitle={`Supercharge your workflow and connect the tools you use everyday`}/>
    );
};

export default AppIntegrationHeading;